
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { User, CreditCard } from "lucide-react";

interface BasicInfoFieldsProps {
  form: any;
  onAddressFound: (address: any) => void;
}

const BasicInfoFields: React.FC<BasicInfoFieldsProps> = ({ form, onAddressFound }) => {
  return (
    <div className="p-5 bg-white rounded-lg shadow-sm border border-gray-100">
      <h3 className="text-lg font-medium text-gray-800 mb-4">Informações Básicas</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="nomeTitular"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700">Nome do Titular</FormLabel>
              <FormControl>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <Input placeholder="Nome completo" className="pl-10" {...field} />
                </div>
              </FormControl>
              <FormMessage className="text-xs mt-1" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="documento"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-gray-700">CPF/CNPJ</FormLabel>
              <FormControl>
                <div className="relative">
                  <CreditCard className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
                  <Input placeholder="CPF ou CNPJ" className="pl-10" {...field} />
                </div>
              </FormControl>
              <FormMessage className="text-xs mt-1" />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default BasicInfoFields;
